var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.5,0v511.5H512V0H0.5z M278.9,398.9c0,49.8-29.2,72.5-71.8,72.5c-38.5,0-60.7-19.9-72.2-44l39.2-23.6 c7.5,13.4,14.4,24.7,30.9,24.7c15.8,0,25.8-6.2,25.8-30.3V234.9h48.1V398.9L278.9,398.9z M392.6,471.4c-44.6,0-73.5-21.2-87.6-49.1 l39.2-22.6c10.3,16.8,23.7,29.2,47.4,29.2c19.9,0,32.7-9.9,32.7-23.7c0-16.4-13-22.3-35.1-32l-12-5.1 c-34.7-14.7-57.7-33.3-57.7-72.5c0-36.1,27.5-63.5,70.3-63.5c30.6,0,52.5,10.6,68.3,38.5l-37.4,24c-8.2-14.7-17.1-20.6-30.9-20.6 c-14,0-22.9,8.9-22.9,20.6c0,14.4,8.9,20.2,29.6,29.2l12,5.1c40.9,17.5,63.8,35.4,63.8,75.6C472.2,447.7,438.1,471.4,392.6,471.4 L392.6,471.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.2ed364028a0bdbe6e45dfee080aab83d.svg";
export { ForwardRef as ReactComponent };